import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { MenuItem } from '../interfaces/menu-item.interface';
import { trackById } from '../../../../utils/track-by';
import icPerson from '@iconify/icons-ic/twotone-person';
import icSettings from '@iconify/icons-ic/twotone-settings';
import icAccountCircle from '@iconify/icons-ic/twotone-account-circle';
import icMoveToInbox from '@iconify/icons-ic/twotone-move-to-inbox';
import icListAlt from '@iconify/icons-ic/twotone-list-alt';
import icTableChart from '@iconify/icons-ic/twotone-table-chart';
import icCheckCircle from '@iconify/icons-ic/twotone-check-circle';
import icAccessTime from '@iconify/icons-ic/twotone-access-time';
import icDoNotDisturb from '@iconify/icons-ic/twotone-do-not-disturb';
import icOfflineBolt from '@iconify/icons-ic/twotone-offline-bolt';
import icChevronRight from '@iconify/icons-ic/twotone-chevron-right';
import icArrowDropDown from '@iconify/icons-ic/twotone-arrow-drop-down';
import icBusiness from '@iconify/icons-ic/twotone-business';
import icVerifiedUser from '@iconify/icons-ic/twotone-verified-user';
import icLock from '@iconify/icons-ic/twotone-lock';
import icNotificationsOff from '@iconify/icons-ic/twotone-notifications-off';
import { Icon } from '@visurel/iconify-angular';
import { PopoverRef } from '../../../../components/popover/popover-ref';

export interface OnlineStatus {
  id: 'online' | 'away' | 'dnd' | 'offline';
  label: string;
  icon: Icon;
  colorClass: string;
}

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarUserDropdownComponent implements OnInit {
  items: MenuItem[] = [];

  statuses: OnlineStatus[] = [
    {
      id: 'online',
      label: 'ONLINE',
      icon: icCheckCircle,
      colorClass: 'text-green',
    },
    {
      id: 'away',
      label: 'AWAY',
      icon: icAccessTime,
      colorClass: 'text-orange',
    },
    {
      id: 'dnd',
      label: 'DO_NOT_DISTURB',
      icon: icDoNotDisturb,
      colorClass: 'text-red',
    },
    {
      id: 'offline',
      label: 'OFFLINE',
      icon: icOfflineBolt,
      colorClass: 'text-gray',
    },
  ];

  activeStatus: OnlineStatus = this.statuses[0];

  trackById = trackById;
  icPerson = icPerson;
  icSettings = icSettings;
  icChevronRight = icChevronRight;
  icArrowDropDown = icArrowDropDown;
  icBusiness = icBusiness;
  icVerifiedUser = icVerifiedUser;
  icLock = icLock;
  icNotificationsOff = icNotificationsOff;
  loginUserData;
  constructor(
    private cd: ChangeDetectorRef,
    private popoverRef: PopoverRef<ToolbarUserDropdownComponent>
  ) {}

  ngOnInit() {
    this.loginUserData = JSON.parse(localStorage.getItem('UserInfo'));
    // console.log("this.loginUserData.role", this.loginUserData.role);
    const userRole = this.loginUserData.role;

    if (userRole == 8) {
      this.items = [
        {
          id: '1',
          icon: icAccountCircle,
          label: 'MY_PROFILE',
          description: 'PERSONAL_INFORMATION',
          colorClass: 'text-teal',
          userRole: this.loginUserData.role,
          route: '/apps/settings/users',
        },
      ];
    } else {
      this.items = [
        {
          id: '1',
          icon: icAccountCircle,
          label: 'MY_PROFILE',
          description: 'PERSONAL_INFORMATION',
          colorClass: 'text-teal',
          userRole: this.loginUserData.role,
          route: '/apps/settings/users',
        },
        {
          id: '2',
          icon: icTableChart,
          label: 'BILLING_INFORMATION',
          description: 'PRICING_AND_CURRENT_PLAN',
          colorClass: 'text-purple',
          userRole: this.loginUserData.role,
          route: '/apps/settings/company/membership',
        },
      ];
    }
  }

  setStatus(status: OnlineStatus) {
    this.activeStatus = status;
    this.cd.markForCheck();
  }

  close() {
    this.popoverRef.close();
  }

  logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('userPreference');
    localStorage.removeItem('UserInfo');
    localStorage.clear();
    this.popoverRef.close();
  }
}
